import { gql, type TypedDocumentNode } from "@apollo/client";
import type { InteractionTopicInput } from "./queries";

export type SuggestTopicDescriptionResponse = {
  suggestInteractionTopicDescription: {
    description: string | null;
    configured: boolean;
  };
};

export type SuggestTopicDescriptionVariables = {
  department: string;
  topic: string;
  subtopic?: string;
};

export const SUGGEST_TOPIC_DESCRIPTION_QUERY: TypedDocumentNode<
  SuggestTopicDescriptionResponse,
  SuggestTopicDescriptionVariables
> = gql`
  query SuggestInteractionTopicDescription($department: String!, $topic: String!, $subtopic: String) {
    suggestInteractionTopicDescription(department: $department, topic: $topic, subtopic: $subtopic) {
      description
      configured
    }
  }
`;

export type TopicFinding = {
  topics: string[];
  subtopics: string[];
  severity: string;
  message: string;
  suggestion: string | null;
};

export type AnalyzeTopicsResponse = {
  analyzeInteractionTopics: {
    summary: string;
    findings: TopicFinding[];
    configured: boolean;
  };
};

export type AnalyzeTopicsVariables = {
  department: string;
  topics?: InteractionTopicInput[];
};

export const ANALYZE_TOPICS_QUERY: TypedDocumentNode<AnalyzeTopicsResponse, AnalyzeTopicsVariables> = gql`
  query AnalyzeInteractionTopics($department: String!, $topics: [BackofficeInteractionTopicInput!]) {
    analyzeInteractionTopics(department: $department, topics: $topics) {
      summary
      configured
      findings {
        topics
        subtopics
        severity
        message
        suggestion
      }
    }
  }
`;
